import { capaActiva, removeLegend } from "./capaActiva";
import { getUid } from "ol";
import VectorLayer from "ol/layer/Vector";

//Evento de cambio de capa
export function onLayerVisibilityChange(event, view) {
  console.log(event);
  const layer = event.target;

  //console.log('-- on Layer --',layer)
  //verificar si es base
  const type = layer.get("type");

  if (type != "base") {
    if (layer.getVisible()) {
      //console.log('La capa "' + layerName + '" está ahora visible.');
      if (layer instanceof VectorLayer) {
        console.log("asd");
      } else {
        capaActiva(layer, view, getUid(layer));
      }
    } else {
      //console.log('La capa "' + layerName + '" está ahora oculta.');
      //console.log('capa no visible')
      removeLegend(layer.getSource().getParams().LAYERS);
    }
  }
}
